import { render, staticRenderFns } from "./HomeTwo.vue?vue&type=template&id=10896f42&"
import script from "./HomeTwo.vue?vue&type=script&lang=js&"
export * from "./HomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports